import { FontStyleAPI } from '../../../api/genericLayout/FontStyleAPI';
import { ComponentAPI } from '../../../api/genericLayout/ComponentAPI';

export class FontStyleCommand {
    constructor(appName) {
        this.fontStyleApi = new FontStyleAPI(appName);
        this.componentApi = new ComponentAPI(appName);
    }

    getAvailableTargets(componentType, successCallback, errorCallback) {
        const apiResult = this.componentApi.listFontTargets(componentType);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu a obter os elementos disponíveis para configuração de um tipo de letra");
            }
        });
    }

    getAvailableFonts(successCallback, errorCallback) {
        const apiResult = this.fontStyleApi.listFonts();
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu a obter as fontes disponíveis para configuração de um tipo de letra");
            }
        });
    }

    deleteUploadedFont(fontName, successCallback, errorCallback) {
        const apiResult = this.fontStyleApi.deleteFont(fontName);
        apiResult.then(() => {
            if (undefined !== successCallback) {
                successCallback("Tipo de letra eliminado com sucesso");
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu a eliminar o tipo de letra");
            }
        });
    }
}
